<template>
  <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
   viewBox="0 0 283.4 284.8" style="enable-background:new 0 0 283.4 284.8;" xml:space="preserve">
    <g>
      <defs>
        <rect id="t4_1_" y="85.7" width="113.4" height="113.4"/>
      </defs>
      <clipPath id="t4_2_">
        <use xlink:href="#t4_1_"  style="overflow:visible;"/>
      </clipPath>
      <g class="st0">
        <g>
          <defs>
            <path id="t4_3_" d="M0,190.1V94.7c0-2.4,0.9-4.7,2.6-6.4c1.7-1.7,4-2.6,6.4-2.6h95.4c2.4,0,4.7,0.9,6.4,2.6
              c1.7,1.7,2.6,4,2.6,6.4v95.4c0,2.4-0.9,4.7-2.6,6.4c-1.7,1.7-4,2.6-6.4,2.6H9c-2.4,0-4.7-0.9-6.4-2.6S0,192.5,0,190.1z"/>
          </defs>
          <clipPath id="t4_4_">
            <use xlink:href="#t4_3_"  style="overflow:visible;"/>
          </clipPath>
          <g class="st1">
            <path class="st2" d="M0,199.1V85.7h113.4v113.4H0z"/>
          </g>
        </g>
      </g>
    </g>
    <g>
      <defs>
        <rect id="t4_5_" x="170" y="85.7" width="113.4" height="113.4"/>
      </defs>
      <clipPath id="t4_6_">
        <use xlink:href="#t4_5_"  style="overflow:visible;"/>
      </clipPath>
      <g class="st3">
        <g>
          <defs>
            <path id="t4_7_" d="M170,190.1V94.7c0-2.4,0.9-4.7,2.6-6.4c1.7-1.7,4-2.6,6.4-2.6h95.4c2.4,0,4.7,0.9,6.4,2.6
              c1.7,1.7,2.6,4,2.6,6.4v95.4c0,2.4-0.9,4.7-2.6,6.4c-1.7,1.7-4,2.6-6.4,2.6H179c-2.4,0-4.7-0.9-6.4-2.6S170,192.5,170,190.1z"/>
          </defs>
          <clipPath id="t4_8_">
            <use xlink:href="#t4_7_"  style="overflow:visible;"/>
          </clipPath>
          <g class="st4">
            <path class="st2" d="M170,199.1V85.7h113.4v113.4H170z"/>
          </g>
        </g>
      </g>
    </g>
    <g>
      <defs>
        <rect id="t4_9_" x="90" y="85.7" width="113.4" height="113.4"/>
      </defs>
      <clipPath id="t4_10_">
        <use xlink:href="#t4_9_"  style="overflow:visible;"/>
      </clipPath>
      <g class="st5">
        <g>
          <defs>
            <path id="t4_11_" d="M90,190.1V94.7c0-2.4,0.9-4.7,2.6-6.4c1.7-1.7,4-2.6,6.4-2.6h95.4c2.4,0,4.7,0.9,6.4,2.6
              c1.7,1.7,2.6,4,2.6,6.4v95.4c0,2.4-0.9,4.7-2.6,6.4c-1.7,1.7-4,2.6-6.4,2.6H99c-2.4,0-4.7-0.9-6.4-2.6S90,192.5,90,190.1z"/>
          </defs>
          <clipPath id="t4_12_">
            <use xlink:href="#t4_11_"  style="overflow:visible;"/>
          </clipPath>
          <g class="st6">
            <path class="st2" d="M90,199.1V85.7h113.4v113.4H90z"/>
          </g>
        </g>
      </g>
    </g>
    <g>
      <defs>
        <rect id="t4_13_" x="85.7" width="113.4" height="113.4"/>
      </defs>
      <clipPath id="t4_14_">
        <use xlink:href="#t4_13_"  style="overflow:visible;"/>
      </clipPath>
      <g class="st7">
        <g>
          <defs>
            <path id="t4_15_" d="M94.7,0h95.4c2.4,0,4.7,0.9,6.4,2.6s2.6,4,2.6,6.4v95.4c0,2.4-1,4.7-2.6,6.4c-1.7,1.7-4,2.6-6.4,2.6
              H94.7c-2.4,0-4.7-0.9-6.4-2.6c-1.7-1.7-2.6-4-2.6-6.4V9c0-2.4,1-4.7,2.6-6.4S92.3,0,94.7,0z"/>
          </defs>
          <clipPath id="t4_16_">
            <use xlink:href="#t4_15_"  style="overflow:visible;"/>
          </clipPath>
          <g class="st8">
            <path class="st2" d="M85.7,0h113.4v113.4H85.7V0z"/>
          </g>
        </g>
      </g>
    </g>
    <g>
      <defs>
        <rect id="t4_17_" x="85.7" y="171.4" width="113.4" height="113.4"/>
      </defs>
      <clipPath id="t4_18_">
        <use xlink:href="#t4_17_"  style="overflow:visible;"/>
      </clipPath>
      <g class="st9">
        <g>
          <defs>
            <path id="t4_19_" d="M94.7,171.4h95.4c2.4,0,4.7,0.9,6.4,2.6c1.7,1.7,2.6,4,2.6,6.4v95.4c0,2.4-1,4.7-2.6,6.4s-4,2.6-6.4,2.6
              H94.7c-2.4,0-4.7-0.9-6.4-2.6s-2.6-4-2.6-6.4v-95.4c0-2.4,1-4.7,2.6-6.4C90,172.4,92.3,171.4,94.7,171.4z"/>
          </defs>
          <clipPath id="t4_20_">
            <use xlink:href="#t4_19_"  style="overflow:visible;"/>
          </clipPath>
          <g class="st10">
            <path class="st2" d="M85.7,171.4h113.4v113.4H85.7V171.4z"/>
          </g>
        </g>
      </g>
    </g>
    <g>
      <defs>
        <rect id="t4_21_" x="20" y="20" width="244.8" height="244.8"/>
      </defs>
      <clipPath id="t4_22_">
        <use xlink:href="#t4_21_"  style="overflow:visible;"/>
      </clipPath>
      <g class="st11">
        <g>
          <defs>
            <path id="t4_23_" d="M43,20h198.8c12.7,0,23,10.3,23,23v198.8c0,12.7-10.3,23-23,23H43c-12.7,0-23-10.3-23-23V43
              C20,30.3,30.3,20,43,20z"/>
          </defs>
          <clipPath id="t4_24_">
            <use xlink:href="#t4_23_"  style="overflow:visible;"/>
          </clipPath>
          <g class="st12">
            <path class="st13" d="M20,20h244.8v244.8H20V20z"/>
          </g>
        </g>
      </g>
    </g>
    <g>
      <defs>
        <rect id="t4_25_" x="49.3" y="49.3" width="186.3" height="186.3"/>
      </defs>
      <clipPath id="t4_26_">
        <use xlink:href="#t4_25_"  style="overflow:visible;"/>
      </clipPath>
      <g class="st14">
        <g>
          <defs>
            <circle id="t4_27_" cx="142.4" cy="142.4" r="93.1"/>
          </defs>
          <clipPath id="t4_28_">
            <use xlink:href="#t4_27_"  style="overflow:visible;"/>
          </clipPath>
          <g class="st15">
            <path class="st2" d="M49.3,49.3h186.3v186.3H49.3V49.3z"/>
          </g>
        </g>
      </g>
    </g>
  </svg>
</template>

<script>
export default {
  name: 't4'
}
</script>

<style scoped>
  svg {
    width: 100%;
    height: 100%;
/*    fill: var(--principal);*/
/*    filter: brightness(0.9); */
  }
</style>

<style scoped>
  .st0{clip-path:url(#t4_2_);}
  .st1{clip-path:url(#t4_4_);}
  .st2{fill:#2C6EDF;}
  .st3{clip-path:url(#t4_6_);}
  .st4{clip-path:url(#t4_8_);}
  .st5{clip-path:url(#t4_10_);}
  .st6{clip-path:url(#t4_12_);}
  .st7{clip-path:url(#t4_14_);}
  .st8{clip-path:url(#t4_16_);}
  .st9{clip-path:url(#t4_18_);}
  .st10{clip-path:url(#t4_20_);}
  .st11{clip-path:url(#t4_22_);}
  .st12{clip-path:url(#t4_24_);}
  .st13{fill:#85B0F9;}
  .st14{clip-path:url(#t4_26_);}
  .st15{clip-path:url(#t4_28_);}
</style>


// WEBPACK FOOTER //
// src/components/Dashboard/Views/PosSettings/svg/t4.vue